/* eslint-disable no-plusplus */
/* eslint-disable global-require */
const GTM = require('../datalayer');

const sendDataOfCheckoutSuccess = () => {
    if (window.dataLayer) {
        const datalayerSuccessElem = $('#datalayerSuccess');
        const ordersuccess = datalayerSuccessElem.data('datalayersuccess');
        const productListID = datalayerSuccessElem.data('prodsuccesslist');
        const controllerURL = datalayerSuccessElem.data('datalayersuccessurl');

        $.ajax({
            url: controllerURL,
            data: {
                productListID: JSON.stringify(productListID),
                orderSuccess: JSON.stringify(ordersuccess.data),
            },
            method: 'GET',
        }).done((datalayerSuccess) => {
            GTM.trackCheckoutSuccess(datalayerSuccess);
        });
    }
};

jQuery(() => {
    if (window.dataLayer) {
        sendDataOfCheckoutSuccess();
    }
});
